import { render, staticRenderFns } from "./UserDebug.vue?vue&type=template&id=afb9cf04&"
import script from "./UserDebug.vue?vue&type=script&lang=js&"
export * from "./UserDebug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports